import React from "react";
import { JointLandingScreenProps } from "./types";

export const JointLandingScreen: React.FC<JointLandingScreenProps> = ({ caseId }) => {
  return <div>JointLandingScreen for caseId: {caseId}</div>;
};
